import firebase from 'firebase'

firebase.initializeApp(process.env.dbconfig)

export default {
  auth: firebase.auth(),
  google: new firebase.auth.GoogleAuthProvider(),
  db: firebase.database()
}



// WEBPACK FOOTER //
// ./src/firebase-config.js